"use strict";

function GtmService($window, campaignService) {
	var dataLayer = $window.dataLayer;

	function addStandardTrackingToDataLayer(obj) {
		if (dataLayer) {
			if (dataLayer.length > 0) {
				var dataLayerLastItem = dataLayer[dataLayer.length - 1];
				var isMatched = (obj.event == dataLayerLastItem.event && 
					obj.eventAction == dataLayerLastItem.eventAction && 
					obj.eventCategory == dataLayerLastItem.eventCategory && 
					obj.eventLabel == dataLayerLastItem.eventLabel && 
					obj.nonInteraction == dataLayerLastItem.nonInteraction);

				if (!isMatched) {
					dataLayer.push(obj);
				}
			}
			else {
				dataLayer.push(obj);
			}
		}		
	}

	function trackTransactionCompleted(page, policyDetails, quoteModel, paymentRef, receiptNumber, paymentType) {
		var selectedQuote = quoteModel.selectedQuoteForPayment,
			offering = quoteModel.offering,
			coverType = selectedQuote ? selectedQuote.coverType : null,
			combinedCoverType = getCombinedCoverType(coverType, offering),
			paymentPlan = selectedQuote ? selectedQuote.paymentPlan : null,
			activeCampaign = campaignService.getCampaign(),
			campaignId = activeCampaign ? activeCampaign.sc_camp : null;

		var trackingData = {
			event: "virtualPageTransaction",
			virtualPageUrl: page.url,
			virtualPageTitle: page.name,
			productCode: quoteModel.productCode,
			transactionId: policyDetails.policyNumber,
			transactionAffiliation: quoteModel.gtmTransactionAffiliation,
			transactionTotal: selectedQuote ? selectedQuote.totalPremium : null,
			totalFSL: selectedQuote ? selectedQuote.totalFSL : null,
			totalGST: selectedQuote ? selectedQuote.totalGST : null,
			totalStampDuty: selectedQuote ? selectedQuote.totalStampDuty : null,
			data: {
				paymentReference: paymentRef,
				policyId: policyDetails.policyNumber,
				receiptNumber: receiptNumber,
				paymentType: paymentType,
			},
			transactionProducts: [
				{
					sku: quoteModel.productCode,
					name: quoteModel.productCode,
					category: combinedCoverType,
					coupon: quoteModel.campaignCode,
					paymentFrequency: paymentPlan
						? paymentPlan.paymentFrequency
						: null,
					price: selectedQuote
						? selectedQuote.premiumAfterDiscount
						: null,
					quantity: 1
				}
			]
		};
		dataLayer.push(trackingData);
	}

	function trackTransaction(page, policyDetails, quoteModel) {
		var selectedQuote = quoteModel.selectedQuoteForPayment,
			offering = quoteModel.offering,
			coverType = selectedQuote ? selectedQuote.coverType : null,
			combinedCoverType = getCombinedCoverType(coverType, offering),
			paymentPlan = selectedQuote ? selectedQuote.paymentPlan : null,
			activeCampaign = campaignService.getCampaign(),
			campaignId = activeCampaign ? activeCampaign.sc_camp : null;

		var trackingData = {
			event: "virtualPageTransaction",
			virtualPageUrl: page.url,
			virtualPageTitle: page.name,
			productCode: quoteModel.productCode,
			transactionId: policyDetails.policyNumber,
			transactionAffiliation: quoteModel.gtmTransactionAffiliation,
			transactionTotal: selectedQuote ? selectedQuote.totalPremium : null,
			totalFSL: selectedQuote ? selectedQuote.totalFSL : null,
			totalGST: selectedQuote ? selectedQuote.totalGST : null,
			totalStampDuty: selectedQuote ? selectedQuote.totalStampDuty : null,
			transactionProducts: [
				{
					sku: quoteModel.productCode,
					name: quoteModel.productCode,
					category: combinedCoverType,
					coupon: quoteModel.campaignCode,
					paymentFrequency: paymentPlan
						? paymentPlan.paymentFrequency
						: null,
					price: selectedQuote
						? selectedQuote.premiumAfterDiscount
						: null,
					quantity: 1
				}
			]
		};
		dataLayer.push(trackingData);
	}

	function getCombinedCoverType(coverType, offering) {
		var combinedCoverType = null;
		if (coverType) {
			combinedCoverType = coverType;
			if (offering) {
				combinedCoverType += "_" + offering;
			}
		}
		return combinedCoverType;
	}

	function trackEvent(eventName, evt) {
		var trackingData = {};

		if (evt === "validationError") {
			trackingData = {
				validationError: eventName
			};
		} else if (evt === "paymentError") {
			trackingData = {
				paymentError: eventName
			};
		} else if (evt === "formValidationError") {
			trackingData = eventName;
		}
		else {
			trackingData = {
				event: eventName
			};
		}

		dataLayer.push(trackingData);
	}

	/////gdd-8403
	function getSha256(dataString) {
		if (!dataString) { return null; }
		return sha256(dataString);
	}

	function streetTypeAbbreviation(addressLine) {		
		if (!addressLine) { return null; }
		return addressLine.trim().toLowerCase()
				.replace(' street', 'st').replace(' road', 'rd')
				.replace(' alley', 'ally').replace(' arcade', 'arc')
				.replace(' avenue', 'ave').replace(' boulevard', 'bvd')
				.replace(' bypass', 'bypa').replace(' circuit', 'cct')
				.replace(' close', 'cl').replace(' corner', 'crn')
				.replace(' court', 'ct').replace(' crescent', 'cres')
				.replace(' cul-de-sac', 'cds').replace(' drive', 'dr')
				.replace(' esplanade', 'esp').replace(' green', 'grn')
				.replace(' grove', 'gr').replace(' highway', 'hwy')
				.replace(' junction', 'jnc').replace(' parade', 'pde')
				.replace(' place', 'pl').replace(' ridge', 'rdge')
				.replace(' terrace', 'tce');
	}

	function nomalizeAddress(quoteModel) {
		if (!quoteModel || !quoteModel.address) {
			return null;
		}
		var addr = quoteModel.address;
		var address = streetTypeAbbreviation(addr.addressLine1)
						 + addr.city + addr.state + addr.postalCode;		
		return address.replace(/\s|,|:|-|AU_|_||\(|\)|'|\/|\./gi, '')
					  .trim().toLowerCase();
	}

	function harshAddress(quoteModel) {
		return getSha256(nomalizeAddress(quoteModel));
	}

	function harshEmail(emailAddress) {
		if (!emailAddress) { return null; }
		return getSha256(emailAddress.trim().replace(/\s/gi, '').toLowerCase());
	}

	function harshPhoneNumber(phoneNo) {
		if (!phoneNo) { return null; }
		return getSha256(phoneNo.trim().replace(/\s|-/gi, '').toLowerCase());
	}

	function harshRego(regoNo) {
		if (!regoNo) { return null; }
		return getSha256(regoNo.trim().replace(/\s/gi, '').toLowerCase());
	}

	function getPhoneNumber(quoteModel) {
		if (!quoteModel) { return null; }
		if (quoteModel.insuranceType === 'Bike') {
			if (!quoteModel 
				|| !quoteModel.gtmPolicyHolder 
				|| !quoteModel.gtmPolicyHolder.phoneNumber) {
				return null;
			}
			return quoteModel.gtmPolicyHolder.phoneNumber;
		}
		if (quoteModel.insuranceType === 'Caravan') {
			if (!quoteModel 
				|| !quoteModel.mainPolicyHolder 
				|| !quoteModel.mainPolicyHolder.primaryPhoneNumber) {
				return null;
			}
			return quoteModel.mainPolicyHolder.primaryPhoneNumber;
		}
		return null;
	}
	/////End gdd-8403

	function trackPageView(page, quoteModel) {
		//dd-6334 - do not trigger this event for Unauth Payments
		if (quoteModel.gtmTransactionAffiliation !== "payments") {
			var selectedQuote = quoteModel.selectedQuoteForPayment
					? quoteModel.selectedQuoteForPayment
					: null,
				offering = quoteModel.offering,
				coverType = selectedQuote ? selectedQuote.coverType : null,
				combinedCoverType = getCombinedCoverType(coverType, offering),
				gtmPolicyHolder = quoteModel.gtmPolicyHolder,
				postCode = quoteModel.postCode,
				activeCampaign = campaignService.getCampaign(),
				campaignId = activeCampaign ? activeCampaign.sc_camp : null;

			var trackingData = {
				event: "virtualPageView",
				virtualPageUrl: page.url,
				virtualPageTitle: page.name,
				qqOption: selectedQuote ? selectedQuote.totalPremium : null,
				qqEstimate: selectedQuote ? selectedQuote.totalPremium : null,
				DOB: gtmPolicyHolder
					? moment(gtmPolicyHolder.dateOfBirth, "DD/MM/YYYY").format(
							"DD/MM/YYYY"
					  )
					: null,
				custGender: gtmPolicyHolder ? gtmPolicyHolder.gender : null,
				postCode: postCode,
				insuranceType: quoteModel.insuranceType,
				coverType: combinedCoverType,
				quoteNo: quoteModel.quoteId,
				sitecoreCampaignId: campaignId,
				attributes: {
					route: page.url
				},
				data: {
					registrationHash: harshRego((quoteModel.regoDetails) ? quoteModel.regoDetails.regoNumber : null),
					emailHash: harshEmail(quoteModel.email),
					phoneHash: harshPhoneNumber(getPhoneNumber(quoteModel)),
					addressHash: harshAddress(quoteModel)
				}
			};
			dataLayer.push(trackingData);
		}
	}

	/*
	 * dd-6181-function to track events for unauthenticated payments
	 * parameters-page data, payment data
	 * return-none
	 */
	function trackUnauthPayments(page, paymentData, paymentType, receiptNumber, policyNumber) {
		var trackingData;

		if (page.name == "payments.payments") {
			trackingData = {
				event: "VirtualPageview",
				virtualPageUrl: page.url,
				virtualPageTitle: page.progressBarShortTitle,
				productCode: paymentData.selectInsuranceType,
				paymentRef: paymentData.enterPaymentRef,
				paymentMethod: paymentData.howToPay
			};
		} else {
			trackingData = {
				event: "virtualPageTransaction",
				virtualPageUrl: page.url,
				virtualPageTitle: page.progressBarShortTitle,
				transactionId: paymentData.transactionId,
				transactionTotal: paymentData.amount.amountPay,
				profile: "QBE Direct Online",
				data: {
					paymentReference: paymentData.referenceNumber,
					policyId: policyNumber,
					receiptNumber: receiptNumber,
					paymentType: paymentType,
				},
				transactionProducts: [
					{
						sku: paymentData.transactionId,
						name: paymentData.transactionId,
						coupon: "",
						price: paymentData.amount.amountPay,
						quantity: 1
					}
				]
			};
		}

		dataLayer.push(trackingData);
	}

	function trackCTPEvent(type, page, action) {
		var trackingData;
		var url = page.url.split("?");

		switch (type) {
			case "gaClick":
				trackingData = {
					event: type,
					eventCategory: page.progressBarTitle,
					eventAction: action,
					eventLabel: url[0]
				};
				break;
			case "VirtualPageview":
				trackingData = {
					event: type,
					virtualPageUrl: url[0],
					virtualPageTitle: "Summary"
				};
				break;
			case "gaFormSubmission":
				trackingData = {
					event: type,
					eventCategory: page.progressBarTitle,
					eventAction: action.event,
					eventLabel: url[0],
					expiryDate: action.expiryDate,
					paymentNumber: action.paymentNumber,
					clientNumber: action.clientNumber
				};
				break;
			default:
		}

		dataLayer.push(trackingData);
	}

	function trackStandardEvent(category, action, label, nonInteraction) {
		if (!$window.qbeTrack) {
			return;
		}

		var item = {
			event: 'standard',
			eventCategory: category, 
			eventAction: action,
			eventLabel: label,
			nonInteraction: nonInteraction
		};

		addStandardTrackingToDataLayer(item);
	}

	function trackProductSelect(productType) {
		if (!$window.qbeTrack || !productType) {
			return;
		}
		$window.qbeTrack.meta.appProduct = productType;
		trackStandardEvent('click drop down', 'Select Insurance Type', productType, false);
	}

	function trackTooltipMouseOver(tooltipMessage) {
		trackStandardEvent('mouse over', 'tooltip', tooltipMessage, false);
	}

	function trackPayBillVirtualPageLanding() {		
		dataLayer.push({
			event: 'virtualPageView',
			virtualPagePath: '/au/pay-bills/welcome',
			virtualPageTitle: 'Welcome - Pay My Bills | QBE AU',
		});
	}

	function trackPayBillVirtualBillFound(paymentRef, policyNumber) {
		var dataObj = {
			paymentReference: paymentRef,
			policyId: policyNumber,
		};

		dataLayer.push({
			event: 'virtualPageView',
			virtualPagePath: '/au/pay-bills/bill-found',
			virtualPageTitle: 'Bill Found - Pay My Bills | QBE AU',
			data: dataObj,
		});
	}

	function trackPayBillVirtualPageDetails(paymentRef, policyNumber, paymentType) {
		var dataObj = {
			paymentReference: paymentRef,
			policyId: policyNumber,
		};
		if (paymentType) {
			dataObj.paymentType = paymentType;
		}

		dataLayer.push({
			event: 'virtualPageView',
			virtualPagePath: '/au/pay-bills/payment-details',
			virtualPageTitle: 'Payment Details- Pay My Bills | QBE AU',
			data: dataObj,
		});
	}

	function trackApiError(errCode, errMessage) {
		dataLayer.push({
			event: 'standard',
			eventCategory: 'error',
			eventAction: 'api',
			eventLabel: errMessage, 
			nonInteraction: true,
			data: {
				errorCode: (!errCode) ? '(not set)' : errCode,
			}
		});
	}

	function createGtmValidationErrorEvent(errorMessageTitle) {
		return {
			event: 'validation_error',
			eventCategory: 'validation error',
			eventAction: 'validation error',
			eventLabel: errorMessageTitle, // error validation title
		};
	}

	return {
		trackTransaction: trackTransaction,
		trackTransactionCompleted: trackTransactionCompleted,
		trackPageView: trackPageView,
		trackEvent: trackEvent,
		trackUnauthPayments: trackUnauthPayments,
		trackCTPEvent: trackCTPEvent,
		trackStandardEvent: trackStandardEvent,
		trackProductSelect: trackProductSelect,
		trackTooltipMouseOver: trackTooltipMouseOver,
		trackPayBillVirtualPageLanding: trackPayBillVirtualPageLanding,
		trackPayBillVirtualBillFound: trackPayBillVirtualBillFound,
		trackPayBillVirtualPageDetails: trackPayBillVirtualPageDetails,
		trackApiError: trackApiError,
		createGtmValidationErrorEvent: createGtmValidationErrorEvent,
	};
}